export default __webpack_public_path__ + "MBD-Teilnahmebedingungen_final.pdf";